import { fetchInvestmentIdea } from './ai';

export const PUSH_PICK_LIMIT = 10;

export async function searchPushPicks(value) {
    const ticker = value.trim().toUpperCase();
    const result = await fetchInvestmentIdea({
        'page.num': 1, 'page.size': PUSH_PICK_LIMIT, status: 1, ...(ticker ? { ticker } : {}),
    });
    if (!result) throw new Error('Pick 查询失败，请检查登录状态和 Pick 查看权限。');
    const matches = new Map();
    for (const pick of result.list || []) {
        if (String(pick.status) !== '1') continue;
        // Keep uint64 IDs as strings; never accept an already-rounded JS number.
        if (typeof pick.id !== 'string' && !Number.isSafeInteger(pick.id)) continue;
        const id = String(pick.id);
        if (!/^[1-9]\d{0,19}$/.test(id) || BigInt(id) > BigInt('18446744073709551615') || !pick.ticker) continue;
        if (!matches.has(id)) matches.set(id, { ...pick, id });
    }
    return [...matches.values()]
        .sort((a, b) => Number(b.ticker.toUpperCase() === ticker) - Number(a.ticker.toUpperCase() === ticker))
        .slice(0, PUSH_PICK_LIMIT);
}
